import React from "react";
import T from "./t.jsx";
import { EMAIL_REGEXP, displayErrors } from "./validation.jsx";
import classNames from "classnames";
import update from "immutability-helper";
import { PropTypes } from "prop-types";

/**
 * Props:
 *   data: Map({
 *     errors:  Array<string>,
 *     emails:    array,
 *     dirty:   boolean
 *   })
 */
export default class SignEmails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      invalidEmail: true,
      multipleFields: [],
      fixEmails: []
    };

    this.addEmail = () => {
      if (this.state.invalidEmail) {
        return;
      }
      let { data } = this.props;
      let emails = data.get("emails", []);
      emails.push(this.state.email);
      if (this.state.multipleFields.length === 0 && this.props.isRequired) {
        data = data.set("errors", []);
      }
      data = data.set("emails", emails);
      this.props.onChange(data, true);
      this.setState({
        email: "",
        invalidEmail: true
      });
    };

    this.removeEmail = email => {
      let { data } = this.props;
      let emails = data.get("emails", []);
      emails.splice(emails.indexOf(email), 1);
      data = data.set("emails", emails);
      if (
        this.state.multipleFields.length === 0 &&
        this.props.isRequired &&
        emails.length === this.state.fixEmails.length
      ) {
        data = data.set("errors", ["question-required"]);
      }

      this.props.onChange(data, true);
      this.setState({
        email: "",
        invalidEmail: true
      });
    };

    this.onChange = e => {
      this.setState(
        {
          email: e.target.value
        },
        () => {
          this.setState({
            invalidEmail: !this.validate(this.state.email)
          });
        }
      );
    };

    this.validate = email => {
      if (!EMAIL_REGEXP.test(email)) {
        return false;
      }

      return true;
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.multipleFields !== prevState.multipleFields) {
      let { data } = this.props;
      let emails = data.get("emails", []);
      this.state.multipleFields.forEach((v, i) => {
        emails[i] = v;
      });

      data = data.set("emails", emails);

      if (this.props.isRequired) {
        if (
          !this.state.multipleFields.some(v =>
            !this.validate(v) ? true : false
          )
        ) {
          data = data.set("errors", []);
        } else {
          data = data.set("errors", ["question-required"]);
        }
      }

      this.props.onChange(data, true);
    }
  }

  componentWillMount() {
    if (
      typeof this.props.signNumOfFields === "number" &&
      this.props.signNumOfFields > 0
    ) {
      this.setState(
        {
          multipleFields: [...Array(this.props.signNumOfFields).keys()].map(
            () => {
              return "";
            }
          )
        },
        () => {
          let { data } = this.props;
          let emails = data.get("emails", []);
          this.state.multipleFields.forEach(v => {
            emails.push(v);
          });

          data = data.set("emails", emails);
          this.props.onChange(data);
        }
      );
    }

    if (this.props.signFixEmails) {
      this.setState(
        {
          fixEmails: this.props.signFixEmails.split(",").map(v => {
            return v.trim();
          })
        },
        () => {
          let { data } = this.props;
          let emails = data.get("emails", []);
          this.state.fixEmails.forEach(v => {
            emails.push(v);
          });
          data = data.set("emails", emails);
          this.props.onChange(data);
        }
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.keyPrefix !== nextProps.keyPrefix) {
      let emails = [];
      let { data } = nextProps;
      this.setState(
        {
          email: "",
          invalidEmail: true,
          multipleFields: [],
          fixEmails: []
        },
        () => {
          if (
            typeof nextProps.signNumOfFields === "number" &&
            nextProps.signNumOfFields > 0
          ) {
            this.setState(
              {
                multipleFields: [
                  ...Array(nextProps.signNumOfFields).keys()
                ].map(() => {
                  return "";
                })
              },
              () => {
                this.state.multipleFields.forEach(v => {
                  emails.push(v);
                });

                data = data.set("emails", emails);
                nextProps.onChange(data);
              }
            );
          }

          if (nextProps.signFixEmails) {
            this.setState(
              {
                fixEmails: nextProps.signFixEmails.split(",").map(v => {
                  return v.trim();
                })
              },
              () => {
                this.state.fixEmails.forEach(v => {
                  emails.push(v);
                });
                data = data.set("emails", emails);
                nextProps.onChange(data);
              }
            );
          }
        }
      );
    }
  }

  render() {
    let { multipleFields } = this.state;

    return (
      <div className="container--slim row">
        {(typeof this.props.signNumOfFields === "number" &&
          this.props.signNumOfFields > 0) ||
        this.props.signMultipleFields ? (
          <div>
            <div className="row">
              <T component="h3" className="text-height">
                {"email-to-sign-description"}
              </T>
            </div>
            {this.props.meta && this.props.meta && this.props.meta.esignMessage && <div className="row">
                <div className="skin" style={{background: "#56fcfe"}}>
                  {this.props.meta.esignMessage}
                </div>
            </div>}
            

            {this.props.signFixEmails ? (
              <div className="row">
                <strong>
                  <T component="span">{"fix-emails"}</T>
                </strong>
                : {this.props.signFixEmails}
              </div>
            ) : null}

            <div className="question__list-header question__list-header--source">
              <div className="row">
                {this.props.signMultipleFields ? (
                  <T
                    component="h4"
                    className={classNames("text-height", {
                      required: this.props.isRequired
                    })}
                  >
                    {"email-to-sign-multiple"}
                  </T>
                ) : (
                  <T
                    component="h4"
                    className={classNames("text-height", {
                      required: this.props.isRequired
                    })}
                  >
                    {"email-to-sign-at-least-one-email"}
                  </T>
                )}

                {multipleFields && multipleFields.length > 0
                  ? multipleFields.map((value, key) => (
                      <div key={key} className="row--small">
                        <input
                          className="submitter-copy__input"
                          type="text"
                          value={multipleFields[key]}
                          placeholder={this.context.translate.translate(
                            "sign-add-email"
                          )}
                          onChange={e => {
                            this.setState({
                              multipleFields: update(multipleFields, {
                                [key]: { $set: e.target.value }
                              })
                            });
                          }}
                        />
                      </div>
                    ))
                  : null}

                {this.props.signMultipleFields ? (
                  <div>
                    <div>
                      <input
                        value={this.state.email}
                        className="submitter-copy__input"
                        type="text"
                        onChange={this.onChange}
                      />
                      <button
                        disabled={this.state.invalidEmail}
                        type="button"
                        onClick={this.addEmail}
                        className={
                          "icon-only button" +
                          (this.state.invalidEmai ? "" : " button--positive")
                        }
                      >
                        <i className="fa fa-plus" />
                      </button>
                    </div>
                    <ul className="row question__list-body">
                      {this.props.data
                        .get("emails", [])
                        .filter((v, i) => {
                          return (
                            i >
                            this.state.fixEmails.length +
                              this.state.multipleFields.length -
                              1
                          );
                        })
                        .map((email, i) => (
                          <li key={i} className="row--small">
                            {email}
                            <a
                              className="icon-only text-right"
                              onClick={this.removeEmail.bind(this, email)}
                            >
                              <i className="fa fa-close" />
                            </a>
                          </li>
                        ))}
                    </ul>
                  </div>
                ) : null}

                {displayErrors(this.props.data)}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

SignEmails.contextTypes = {
  translate: PropTypes.shape({
    translate: PropTypes.func.isRequired
  }).isRequired
};
